import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  ViewChild,
  inject,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { toPng } from 'dom-to-image';
import { SingleValueKPI } from '../../types';
import { SingleValueModalComponent } from './single-value-modal/single-value-modal.component';

@Component({
  selector: 'app-single-value',
  templateUrl: './single-value.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SingleValueComponent {
  @Input({ required: true }) data: SingleValueKPI;

  @Input() loading: boolean = false;

  @Input() ngClass: string | string[] | Set<string> | { [klass: string]: any } =
    '';

  private readonly matDialog = inject(MatDialog);

  @ViewChild('modalContent') modalContent: ElementRef | undefined;

  downloadImage(): void {
    const contentElement = this.modalContent?.nativeElement as
      | HTMLElement
      | undefined;

    if (typeof contentElement === 'undefined') {
      return;
    }

    const options = {
      height: contentElement.offsetHeight,
      width: contentElement.offsetWidth,
      scale: 1.5,
      style: {
        transform: 'scale(1)',
        transformOrigin: 'top center',
      },
    };

    toPng(contentElement, options)
      .then((dataUrl) => {
        const link = document.createElement('a');
        link.href = dataUrl;
        link.download = 'component-image.png';
        link.click();
      })
      .catch((error) => {
        console.error('Error', error);
      });
  }

  openModal(): void {
    this.matDialog.open<SingleValueModalComponent, SingleValueKPI>(
      SingleValueModalComponent,
      {
        width: 'calc(100vw - 1rem)',
        hasBackdrop: true,
        data: this.data,
        ariaLabelledBy: 'single-value-dialog-title',
      },
    );
  }

  // turn numbers like 10000000 into 10,000,000
  formatValue(value: keyof any): string {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
}
